
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BlueButton',
  props: {
    showResult: {
      type: Boolean,
      required: true,
    },
    isCorrect: {
      type: Boolean,
      required: true,
    },
  },
})
